import script from "./OrderInfoTopBar.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderInfoTopBar.vue?vue&type=script&setup=true&lang=js"

import "./OrderInfoTopBar.vue?vue&type=style&index=0&id=60de5cac&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60de5cac"]])

export default __exports__